import { render, staticRenderFns } from "./Income-history.vue?vue&type=template&id=0f8204ea&scoped=true&"
import script from "./Income-history.vue?vue&type=script&lang=js&"
export * from "./Income-history.vue?vue&type=script&lang=js&"
import style0 from "./Income-history.vue?vue&type=style&index=0&id=0f8204ea&prod&lang=scss&scoped=scoped&"
import style1 from "./Income-history.vue?vue&type=style&index=1&id=0f8204ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8204ea",
  null
  
)

export default component.exports